import { companyCompensationComplianceApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const COMPENSATION_COMPLIANCE_ACTION_TYPE = createNamedActions('compensationCompliance', {
  GET_CONFIG: 'GET_CONFIG',
  UPDATE_CONFIG: 'UPDATE_CONFIG',
});

export const getCompensationComplianceConfigAction = catchAsyncActionError(
  params => async dispatch => {
    const { data } = await companyCompensationComplianceApi.getConfig(params);

    return dispatch({
      type: COMPENSATION_COMPLIANCE_ACTION_TYPE.GET_CONFIG,
      payload: data,
    });
  },
);

export const updateCompensationComplianceConfigAction = catchAsyncActionError(
  params => async dispatch => {
    const { data } = await companyCompensationComplianceApi.updateConfig(params);

    return dispatch({
      type: COMPENSATION_COMPLIANCE_ACTION_TYPE.UPDATE_CONFIG,
      payload: data,
    });
  },
);
